/********************************************
 * Accordion
 ********************************************/
function fnProjectsLoadMore(i, oSection) {
  const button = oSection.querySelector(".load-more-button");
  if (!button) return;
  
  const listing = oSection.querySelector("#projects-listing .projects-grid");
  let paged = +button.getAttribute("data-paged");
  const total = +button.getAttribute("data-total");
  const navFilters = document.querySelector("[data-sf-form-id]");

  // Hide filters when reached the bottom of page
  window.addEventListener("scroll", () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 800
    ) {
      navFilters.style.opacity = "0";
    } else {
      navFilters.style.opacity = "1";
    }
  });

  let loading = false;

  button.addEventListener("click", (e) => {
    e.preventDefault();

    if (loading) return;

    ++paged;
    loading = true;
    jQuery("span", button).text("loading");
    button.setAttribute("data-paged", paged);

    const urlParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }
    params.sf_paged = paged;

    const queryString = Object.keys(params)
      .map((key) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
      })
      .join("&");

    fnSetCookie("projectsFilterParams", `/projects/?${queryString}`, 1);

    jQuery.get(`/projects/?${queryString}`, function (data) {
      const items = jQuery("#projects-listing .project-card", data);

      jQuery(listing).append(items);

      loading = false;
      jQuery("span", button).text("Load More");

      if (paged == total) {
        jQuery(button).fadeOut();
      }

      //jQuery(".searchandfilter").trigger("projects:ajaxfinish");
    });
  });
}
